import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Button, 
  Container, 
  Image, 
  Nav, 
  Navbar, 
  NavItem, 
  Offcanvas 
} from "react-bootstrap";
import Logo from '../assets/Logo.png';
import { NAV_LINKS } from '../config/constants';
import { useAuth } from '../hooks/useAuth';
import '../App.css';

export const NavigationBar = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const { logout } = useAuth();

  const handleClose = () => setShow(false);
  
  // Render navigation links
  const renderNavLinks = (isMobile = false) => {
    return (
      <>
        {NAV_LINKS.map((link) => (
          <NavItem key={link.path}>
            <Nav.Link 
              eventKey={link.path} 
              as={Link} 
              to={link.path}
              onClick={isMobile ? handleClose : undefined}
            >
              {link.label}
            </Nav.Link>
          </NavItem>
        ))}
        <NavItem>
          <Nav.Link 
            onClick={logout} 
            as={Link} 
            to="/"
          >
            Logout
          </Nav.Link>
        </NavItem>
      </>
    );
  };
  
  return (
    <>
      <Navbar expand="lg" bg="light" variant="light" fixed="top" sticky="top">
        <Container>
          {/* Brand */}
          <Navbar.Brand as={Link} to="/">
            <Image src={Logo} height="60vw" alt="Logo" />
          </Navbar.Brand>

          {/* Mobile Menu Button */}
          <Button
            variant="outline-dark"
            className="d-lg-none"
            onClick={() => setShow(true)}
            aria-label="Toggle navigation"
          >
            ☰
          </Button>

          {/* Desktop Navigation */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav fill variant="pills" activeKey={location.pathname} className="mr-auto">
              {renderNavLinks()}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Offcanvas (Sidebar) */}
      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Image src={Logo} height="60vw" alt="Logo" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column mobileNav" activeKey={location.pathname}>
            {renderNavLinks(true)}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
